// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --border-color: none;
  --border-width: 0px !important;
  --background: transparent;
  --box-shadow: none;
  --color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/back-button/back-button.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AACJ","sourcesContent":["ion-button {\n    --border-color: none; \n    --border-width: 0px !important;\n    --background: transparent;\n    --box-shadow: none;\n    --color: white !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
